import React from 'react';
import LoginForm from './LoginForm';
import Background from './Background';
import FooterLinks from './FooterLinks';
import './LoginPage.css';

const LoginPage: React.FC = () => {
    return (
        <div className="login-page">
            <LoginForm />
            <Background />
            <FooterLinks />
        </div>
    );
}

export default LoginPage;
